(() => {
  angular
    .module('gm.common.directives')
    .directive('gmDropdownMenuSearch', gmDropdownMenuSearchDirective);

  function gmDropdownMenuSearchDirective(
    $timeout,
    $rootScope
  ) {
    'ngInject';

    return {
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        placeholder: '@',
        up: '&?',
        down: '&?',
        enter: '&?'
      },
      templateUrl:
        'modules/common/directives/dropdown-menu-search/dropdown-menu-search.html',

      link(scope, _element, _attrs, ctrl) {
        scope.filterInput = '';
        scope.filterInputFocus = false;

        scope.$watch('filterInput', filter => ctrl.$setViewValue(filter));
        scope.$watch(() => ctrl.$viewValue, (val) => {
          scope.filterInput = val;
        });

        $rootScope.$on('gm:flyout-opened', () => {
          $timeout(() => {
            scope.filterInputFocus = true;
          }, 400); // require delay due animation
        });

        $rootScope.$on('gm:flyout-closed', () => {
          scope.filterInputFocus = false;
        });
      },
    };
  }
})();
